// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__9hjha","label":"style_label__b++sM"};